<template>
    <Modal
        v-model="modalVisible"
        :width="1200"
        scrollable
        class-name="vertical-center-modal"
        @on-visible-change="onVisibleChange"
    >
        <div slot="header">
            <div class="header-container">
                <div>
                    <p>
                        <span>{{ isEditMode ? "产品编辑" : "产品新增" }}</span>
                        <span
                            v-if="isEditMode"
                            style="margin-left: 20px; color: blue"
                            >{{ productCode }}</span
                        >
                    </p>
                </div>

                <div class="copy-section">
                    <span><b>复制商品信息(全局):</b></span>
                    <ProductSelector ref="productIdSelector1" style="margin-left: 20px;" :productUuid=productId1 :productList=productList @onProductChange="onProductInfo1Change" />
                    
                </div>
            </div>
        </div>
        <Loading :isLoading="saveLoading" />
        <Tabs :animated="false" :capture-focus="true" v-model="editType">
            <TabPane label="基础信息" name="productInfo">
                <ProductPopupEdit
                    ref="productPopupEdit"
                    :formEditMode="formEditMode"
                    :popupEditResource="popupEditResource"
                    :productList="productList"
                    @on-popup-submit-finish="popupSubmitFinish"
                />
            </TabPane>
            <TabPane v-if="isEditMode" label="特别通告" name="productInfo2">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector2" :productUuid=productId2 :productList=productList @onProductChange="onProductInfo2Change" />
                </div>
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="productForm.productDesInfopOtherSpec"
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData('productDesInfopOtherSpec')
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                        <!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="ontherSpecSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="品种介绍" name="productInfo3">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector3" :productUuid=productId3 :productList=productList @onProductChange="onProductInfo3Change" />
                </div>
                
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="productForm.productDesInffeatures"
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="getUploadData('productDesInffeatures')"
                            :qillHeight="qillHeight"
                        ></quill-upload>
                        <!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onFeaturesSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
                    </Col>
                </Row>
                <Row justify="center"> </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="栽培技术" name="productInfo4">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector4" :productUuid=productId4 :productList=productList @onProductChange="onProductInfo4Change" />
                </div>
                
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="productForm.productDesInfoCultivation"
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData('productDesInfoCultivation')
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                        <!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onCultivationSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="常见问题" name="productInfo5">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector5" :productUuid=productId5 :productList=productList @onProductChange="onProductInfo5Change" />
                </div>
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="productForm.productDesInfoCommonProblem"
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData('productDesInfoCommonProblem')
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                        <!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onCommonProblemSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="关于售后" name="productInfo6">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector6" :productUuid=productId6 :productList=productList @onProductChange="onProductInfo6Change" />
                </div>
                
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="productForm.productDesInfoafterService"
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData('productDesInfoafterService')
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                        <!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onproductDesInfoafterServiceSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="优惠政策" name="productInfo7">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector7" :productUuid=productId7 :productList=productList @onProductChange="onProductInfo7Change" />
                </div>
                
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="productForm.productDesInfodiscountPolicy"
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData('productDesInfodiscountPolicy')
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                        <!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onproductDesInfodiscountPolicySubmit">保存</Button>
						</ButtonGroup>
					</div> -->
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="PDF目录" name="productInfo8">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector8" :productUuid=productId8 :productList=productList @onProductChange="onProductInfo8Change" />
                </div>
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <pdf-upload
                            :productUuid="productUuid"
                            v-model="productForm.productDesInfoPdfLinkList"
                            :uploadData="
                                getUploadData('productDesInfoPdfLinkList')
                            "
                            :qillHeight="qillHeight"
                        ></pdf-upload>
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="病虫防治" name="productInfo9">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector9" :productUuid=productId9 :productList=productList @onProductChange="onProductInfo9Change" />
                </div>
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="
                                productForm.productDesInfoDiseasePestControl
                            "
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData(
                                    'productDesInfoDiseasePestControl'
                                )
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                    </Col>
                </Row>
            </TabPane>
            <TabPane v-if="isEditMode" label="采后处理" name="productInfo10">
                <div class="copy-section">
                    <span><b>复制商品信息(局部):</b></span>
                    <ProductSelector ref="productIdSelector10" :productUuid=productId10 :productList=productList @onProductChange="onProductInfo10Change" />
                </div>
                <Row justify="center" class="quillRow">
                    <Col span="20" offset="2">
                        <quill-upload
                            v-model="
                                productForm.productDesInfoPostHarvestProcessing
                            "
                            :uploadImgUrl="uploadImgUrlWithPath"
                            :uploadData="
                                getUploadData(
                                    'productDesInfoPostHarvestProcessing'
                                )
                            "
                            :qillHeight="qillHeight"
                        ></quill-upload>
                    </Col>
                </Row>
            </TabPane>
        </Tabs>
        <div slot="footer">
            <Button
                v-if="this.$checkAccessArray(['B', 'C'])"
                type="primary"
                @click="basicInformationubmit"
                >保存基础信息</Button
            >
            <Button
                v-if="this.$checkAccessArray(['B', 'C']) && isEditMode"
                type="primary"
                @click="saveProductDescriptiveInformation"
                >保存说明信息</Button
            >
        </div>
    </Modal>
</template>

<script>
import Loading from "@/components/loading/Loading.vue";
import ProductPopupEdit from "./product-popup-edit-new";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import {
    getProductDescriptiveInformation,
    saveProductDescriptiveInformation
} from "@/api/modules/product-management/productApprove-management";
import { UPLOAD_FILE_API_PATH, FILE_SERVER } from "@/api/modules/files";

import ModalVisible from "@/view/mixins/modal-visible";
import quillUpload from "@/components/quill-upload/quill-upload.vue";
import pdfUpload from "./product-popup-edit-pdfUpload.vue";
import search from '@/libs/search';
import { getProductList } from '@/api/modules/product-management/product-management';
import ProductSelector from '@/components/selector/product-selector.vue';
export default {
    name: "ProductPopupEditTab",
    components: {
        ProductPopupEdit,
        quillUpload,
        ProductSelector,
        Loading,
        pdfUpload
    },
    mixins: [ModalVisible],
    props: {
        productUuid: {
            type: String,
            required: true,
            default: ""
        },
        productCode: {
            type: String,
            required: true,
            default: ""
        },
        // formEditMode:{
        // 		type: String,
        // 		required: true,
        // 		default: FORM_EDIT_MODE_MODIFY
        // 	},
        popupEditResource: {
            type: Object,
            required: true,
            default() {
                return {
                    seedFarmCode: "",
                    mainCategorySource: [],
                    rawSubCategorySource: [],
                    brandSource: [],
                    serialSource: [],
                    unitSource: [],
                    packageSource: [],
                    masterSource: [],
                    allRegionInfo: [],
                    approvalSource: [],
                    packingFee: "",
                    deliveryFee: "",
                    // productCategoryFeature: '',
                    productDesInfoCultivation: 0,
                    demonstrationVideo2: 0,
                    demonstrationVideo3: 0,
                    demonstrationVideo4: 0,
                    demonstrationVideo5: 0,
                    productDesInfodiscountPolicy: 0,
                    productPreSaleDiscountRatio: 0,
                    productFeatureContract: "",
                    pottingSeedling: 0,
                    seedlingHeight: "",
                    leavesNumber: ""
                };
            }
        }
    },
    data() {
        return {
            qillHeight: 440,
            popupEditModalShow: false,
            editType: "productInfo",
            uploadImgUrlWithPath: 'https://up-z2.qiniup.com/',
            FILE_SERVER,
            productId1: '',
            productId2: '',
            productId3: '',
            productId4: '',
            productId5: '',
            productId6: '',
            productId7: '',
            productId8: '',
            productId9: '',
            productId10: '',
            productList:[],
            //formEditMode: this.productUuid ?FORM_EDIT_MODE_MODIFY:FORM_EDIT_MODE_CREATE,
            productForm: {
                productDesInfopOtherSpec: "特别通告",
                productDesInffeatures: "品种特征",
                productDesInfoCultivation: "栽培技术",
                productDesInfoCommonProblem: "常见问题",
                productDesInfoafterService: "关于售后",
                productDesInfodiscountPolicy: "优惠政策",
                productDesInfoPdfLinkList: "pdf列表",
                productDesInfoDiseasePestControl: "病虫防治",
                productDesInfoPostHarvestProcessing: "采后处理"
            },
            saveLoading: false
        };
    },
    watch: {
        // productUuid: {
        // 	handler: function(newValue) {
        // 		if (newValue) {
        // 			this.$refs.productPopupEdit.onVisibleChange(this.productUuid);
        // 		}
        // 	}
        // }
    },
    methods: {
        // ontherSpecSubmit() {
        // 	this.saveProductDescriptiveInformation('productDesInfopOtherSpec');
        // },
        // onFeaturesSubmit() {
        // 		this.saveProductDescriptiveInformation('productDesInffeatures');
        //  },
        // onCultivationSubmit() {
        // 	this.saveProductDescriptiveInformation('productDesInfoCultivation');
        // },
        // onCommonProblemSubmit() {
        // 	this.saveProductDescriptiveInformation('productDesInfoCommonProblem');
        //  },
        // onproductDesInfoafterServiceSubmit() {
        // 	this.saveProductDescriptiveInformation('productDesInfoafterService');
        //  },
        // onproductDesInfodiscountPolicySubmit() {
        // 	this.saveProductDescriptiveInformation('productDesInfodiscountPolicy');
        //  },
        getUploadData(path) {
            let uploadData = {};
            if (this.productUuid) {
                uploadData.updatePath = `${path}/` + this.productUuid;
            }
            else {
                uploadData.updatePath = `${path}`;
            }
            return uploadData;
        },
        popupSubmitFinish(formEditMode, productUuid, productCode) {
            this.$emit(
                "on-popup-submit-finish",
                formEditMode,
                productUuid,
                productCode
            );
        },
        onVisibleChange(view) {
            this.initProductId();
            console.log("productId1", this.productId1);
            this.getProductList();
            if (view) {
                this.editType = "productInfo";
                this.setProductPopupEdit();
                getProductDescriptiveInformation(this.productUuid).then(
                    res => {
                        if (res.code == 0) {
                            this.productForm.productDesInfopOtherSpec
                                = res.data.productDesInfopOtherSpec;
                            this.productForm.productDesInffeatures
                                = res.data.productDesInffeatures;
                            this.productForm.productDesInfoCultivation
                                = res.data.productDesInfoCultivation;
                            this.productForm.productDesInfoCommonProblem
                                = res.data.productDesInfoCommonProblem;
                            this.productForm.productDesInfoafterService
                                = res.data.productDesInfoafterService;
                            this.productForm.productDesInfodiscountPolicy
                                = res.data.productDesInfodiscountPolicy;
                            this.productForm.productDesInfoPdfLinkList
                                = res.data.productDesInfoPdfLinkList;
                            this.productForm.productDesInfoDiseasePestControl
                                = res.data.productDesInfoDiseasePestControl;
                            this.productForm.productDesInfoPostHarvestProcessing
                                = res.data.productDesInfoPostHarvestProcessing;
                        }
                    }
                );
            }
        },
        setProductPopupEdit() {
            this.$refs.productPopupEdit.onVisibleChange(this.productUuid);
        },
        basicInformationubmit() {
            this.$refs.productPopupEdit.onSubmit();
        },
        saveProductDescriptiveInformation() {
            if(this.productForm.productDesInffeatures === '' 
                || this.productForm.productDesInfoCommonProblem === ''
                || this.productForm.productDesInfoCultivation === ''
                || this.productForm.productDesInfoDiseasePestControl === ''
                || this.productForm.productDesInfoPdfLinkList === ''
                || this.productForm.productDesInfoPostHarvestProcessing === ''
                || this.productForm.productDesInfoafterService === ''
                || this.productForm.productDesInfodiscountPolicy === ''
                || this.productForm.productDesInfopOtherSpec === '') {
                this.$Modal.confirm({
                    title: '确认提交',
                    content: '说明信息中还有未填写字段，您确定要提交吗?',
                    onOk: () => {
                        let data = Object.assign({}, this.productForm, {
                            productUuid: this.productUuid
                        });
                        this.saveLoading = true;
                        saveProductDescriptiveInformation(data).then(res => {
                            this.saveLoading = false;
                            if (res.code == 0) {
                                this.$Message.info("保存成功");
                            } 
                            else {
                                this.$Message.info(res.message);
                            }
                        });
                    },
                    onCancel: () => {
                        this.$Message.info('取消提交');
                    }
                });
            }
            else{
                let data = Object.assign({}, this.productForm, {
                    productUuid: this.productUuid
                });
                this.saveLoading = true;
                saveProductDescriptiveInformation(data).then(res => {
                    this.saveLoading = false;
                    if (res.code == 0) {
                        this.$Message.info("保存成功");
                    } 
                    else {
                        this.$Message.info(res.message);
                    }
                });
            }
             
        },
        getProductList(){
            let tableSearch =search.getSearchParams();
            search.closeAllConditions(tableSearch);
            getProductList(tableSearch).then(res => {
                if (res.code === 0) {
                    this.productList = res.data.records;
                }
            });
        },
        getProductDescriptiveInformation(productUuid, Spec=true, features=true, Cultivation=true, CommonProblem=true, afterService=true, discountPolicy=true, pdfLinkList=true, DiseasePestControl=true, PostHarvestProcessing=true){
            getProductDescriptiveInformation(productUuid).then(
                res => {
                    if (res.code == 0) {
                        if(Spec){
                            this.productForm.productDesInfopOtherSpec = res.data.productDesInfopOtherSpec;
                        }
                        if(features){
                            this.productForm.productDesInffeatures = res.data.productDesInffeatures;
                        }
                        if(Cultivation){
                            this.productForm.productDesInfoCultivation = res.data.productDesInfoCultivation;
                        }
                        if(CommonProblem){
                            this.productForm.productDesInfoCommonProblem = res.data.productDesInfoCommonProblem;
                        }
                        if(afterService){
                            this.productForm.productDesInfoafterService = res.data.productDesInfoafterService;
                        }
                        if(discountPolicy){
                            this.productForm.productDesInfodiscountPolicy = res.data.productDesInfodiscountPolicy;
                        }
                        if(pdfLinkList){
                            this.productForm.productDesInfoPdfLinkList = res.data.productDesInfoPdfLinkList;
                        }
                        if(DiseasePestControl){
                            this.productForm.productDesInfoDiseasePestControl = res.data.productDesInfoDiseasePestControl;
                        }
                        if(PostHarvestProcessing){
                            this.productForm.productDesInfoPostHarvestProcessing = res.data.productDesInfoPostHarvestProcessing;
                        }
                    }
                }
            );
        },
        
        initProductId(){
            this.$nextTick(() => {
                if(this.$refs.productIdSelector1) {
                    this.$refs.productIdSelector1.clear();
                    this.productId1 = '';
                }
                if(this.$refs.productIdSelector2) {
                    this.$refs.productIdSelector2.clear();
                    this.productId2 = '';
                }
                if(this.$refs.productIdSelector3) {
                    this.$refs.productIdSelector3.clear();
                    this.productId3 = '';
                }
                if(this.$refs.productIdSelector4) {
                    this.$refs.productIdSelector4.clear();
                    this.productId4 = '';
                }
                if(this.$refs.productIdSelector5) {
                    this.$refs.productIdSelector5.clear();
                    this.productId5 = '';
                }
                if(this.$refs.productIdSelector6) {
                    this.$refs.productIdSelector6.clear();
                    this.productId6 = '';
                }
                if(this.$refs.productIdSelector7) {
                    this.$refs.productIdSelector7.clear();
                    this.productId7 = '';
                }
                if(this.$refs.productIdSelector8) {
                    this.$refs.productIdSelector8.clear();
                    this.productId8 = '';
                }
                if(this.$refs.productIdSelector9) {
                    this.$refs.productIdSelector9.clear();
                    this.productId9 = '';
                }
                if(this.$refs.productIdSelector10) {
                    this.$refs.productIdSelector10.clear();
                    this.productId10 = '';
                }
            });
        },
        onProductInfo1Change(id){
            if (!id) return;
            this.productId2 = id;
            this.productId3 = id;
            this.productId4 = id;
            this.productId5 = id;
            this.productId6 = id;
            this.productId7 = id;
            this.productId8 = id;
            this.productId9 = id;
            this.productId10 = id;
            const product = this.productList.find(e => e.productUuid === id);
            this.getProductDescriptiveInformation(id);
            if (product) {
                this.childProductChange(product);
            }
        },
        onProductInfo2Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, true, false, false, false, false, false, false, false, false);
        },
        onProductInfo3Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, true, false, false, false, false, false, false, false);
        },
        onProductInfo4Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, true, false, false, false, false, false, false);
        },
        onProductInfo5Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, false, true, false, false, false, false, false);
        },
        onProductInfo6Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, false, false, true, false, false, false, false);
        },
        onProductInfo7Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, false, false, false, true, false, false, false);
        },
        onProductInfo8Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, false, false, false, false, true, false, false);
        },
        onProductInfo9Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, false, false, false, false, false, true, false);
        },
        onProductInfo10Change(id){
            if (!id) return;
            this.getProductDescriptiveInformation(id, false, false, false, false, false, false, false, false, true);
        },
        childProductChange(product) {
            this.$refs.productPopupEdit.productCopy(product);
        }
    },
    computed: {
        isEditMode() {
            return this.productUuid ? true : false;
        },
        formEditMode() {
            return this.productUuid
                ? FORM_EDIT_MODE_MODIFY
                : FORM_EDIT_MODE_CREATE;
        }
    }
};
</script>

<style lang="less">
.quillRow {
    margin: 30px 0px 50px 0px;
}
.header-container {
    display: flex;
    align-items: center;
    justify-content: flex-start; /* 关键：左对齐 */
}
.copy-section {
    margin-left: 40px;
}
</style>
